<template lang='pug'>
v-container.tw-flex.tw-flex-col.tw-gap-2.tw-items-center
	p(v-if='!loading && (!carnetSolutions || !bookingStore.servicesMap.catalog_services)') {{$t('sale.carnet_solutions.no_solutions', 'Nessuna solutione trovata')}}

	carnet-solution.tw-w-full(
		v-if='carnetSolutions && !isABooking'
		v-for="(solution, i) in bookingStore.servicesMap.catalog_services"
		:key="solution.id"
		:carnet-solution='solution'
		:train-classification='solution.attrs.train_classification'
		:service-classification='solution.attrs.level'
		:price-list='priceList'
		v-bind:service-id="solution.id"
		:selectedCarnet="selectedCarnet"
		:loading="loadingEvaluation[solution.id]"
		@get-availability="getAvailability"
		@cancel-selection="cancelSelection"
	)
	travel-solution.tw-w-full(
		v-else-if='carnetSolutions && isABooking'
		v-for="(solution, i) in carnetSolutions"
		:key="i"
		:trav-sol='solution'
		:solutionIndex='i'
		:expanded='expandedSolutionIndex == i'
		source='carnet'
		:catalog-services="bookingStore.servicesMap.catalog_services"
		class="emd:tw-mb-2"
		@expand='expandedSolutionIndex = i'
		@unexpand='expandedSolutionIndex = -1'
		@add-to-cart="addToCart"
		ref="selectedService"
	)
	div.tw-white-card.tw-w-full(v-if="carnetSolutions && selectedCarnet >= 0 && loginStore.isLogged")
		h1.tw-text-3xl.text-center.mb-5 {{bookingStore.servicesMap.catalog_services[selectedCarnet].display_name}} - {{formattedPrice}}
		buyer-form.tw-border-none.tw-shadow-none(
			v-if="buy"
			v-bind:isTicketPurchase='false'
			:buyer="bookingStore.buyer.data"
			ref="buyerForm"
		)

		invoice.tw-border-none.tw-shadow-none(ref="invoiceForm")

		div.tw-mt-6.tw-flex.tw-justify-between
			v-btn(flat @click="cancelSelection") {{$t('common.cancel', 'Annulla')}}
			v-btn(color="primary-darken-1" @click="addToCart") {{$t('common.add_tocart', 'Aggiungi al carrello')}}


</template>

<script setup>
import {ref, onMounted, computed, shallowRef, watch, inject} from 'vue';
import {useI18n} from "vue-i18n";
import {useBookingStore, handleEvaluateSolutionResponse} from '@/stores/booking';
import {useBookingStepperStore} from '@/stores/booking-stepper';
import {useLoginDialogStore} from "@/stores/use-login-dialog";
import {useDialogManagerStore} from '@/stores/dialog-manager';
import {printCurrencyValue} from "@/common-scripts/utilities";
import {useTravelSolutionSelection} from '@/composables/travel-solution-selection';
import TravelSolution from '@/sale/components/tab2_travel_solutions/travelSolution.vue';
import CarnetSolution from "@/sale/components/tab2_travel_solutions/carnet/carnetSolution.vue";
import BuyerForm from "@/sale/components/tab3_travellers-data-section/buyer-form.vue";
import Invoice from "@/sale/components/tab3_travellers-data-section/invoice-form.vue";


const expandedSolutionIndex = ref(-1);
const axios = inject('axios');
const stepper = useBookingStepperStore();
const bookingStore = useBookingStore();
const loginStore = useLoginDialogStore();
const dialogManagerStore = useDialogManagerStore();
const loading = ref(true);
const carnetSolutions = shallowRef(null);
const selectedCarnet = ref(-1);
const selectedService = ref(null);
const priceGrid = ref(null);
const buy = ref(true);
const loadingEvaluation = ref({});
const buyerForm = ref();
const invoiceForm = ref();
const travelSolutionSelection = useTravelSolutionSelection(null, {isCarnet: true});

const isABooking = computed(() => {
	return Boolean(bookingStore.carnet.fund);
});
const carnetSolutionType = computed(() => {
	return isABooking.value ? 'carnet-travel-solutions' : 'carnet-available';
});
const i18n = useI18n();
const travelSolution = computed(() => {
	if (!carnetSolutions.value) return;
	return isABooking.value ? carnetSolutions.value : carnetSolutions.value[0];
});
const priceList = computed(() => {
	let result = {};
	if (!carnetSolutions.value) return result;
	for (let k in travelSolution.value.priceGrid) {
		if (!Object.hasOwnProperty.call(travelSolution.value.priceGrid, k)) continue;
		if (travelSolution.value.priceGrid[k].length == 0) continue;

		let offerId = travelSolution.value.priceGrid[k].rows[0];
		result = travelSolution.value.priceGrid[k].matrix[offerId];
	}
	return result;
});
const formattedPrice = computed(() => {
	return printCurrencyValue(priceList.value[selectedCarnet.value].totalMoneyPrice.amount, priceList.value[selectedCarnet.value].totalMoneyPrice.currency);
});


function saveInLocalStore(data) {
	sessionStorage.setItem(carnetSolutionType.value, JSON.stringify(data));
}

function loadFromLocalStore() {
	const carnet = sessionStorage.getItem(carnetSolutionType.value);
	if (!carnet) return;
	carnetSolutions.value = bookingStore.elaborateSearchResponseWithReturnTravelSolutions(JSON.parse(carnet));
	setLoadingEvaluationList();
	loading.value = false;
}

function searchAvailablesCarnet() {
	const loadingDialog = dialogManagerStore.showLoadingDialog({
		title: i18n.t('dialogs.data_check', 'Verifica dati in corso ...')
	});
	loading.value = true;

	let dataToSend = {
		...bookingStore.searchFilters,
		start: bookingStore.searchFilters.startDate.toISOString(),
		carnetId: bookingStore.carnet.selectedCarnetId
	};
	dataToSend.from = dataToSend.departureStation.service_id;
	dataToSend.to = dataToSend.arrivalStation.service_id;
	delete dataToSend.departureStation;
	delete dataToSend.arrivalStation;
	delete dataToSend.filterSolution;
	delete dataToSend.returnDate;
	delete dataToSend.startDate;
	delete dataToSend.direction;

	axios.post("trenitalia/search-availables-carnet", dataToSend)
			.then((response) => response.data)
			.then(async (response) => {
				if ((Array.isArray(response) && response.length === 0) || (response.data && Object.keys(response.data).length === 0)) {
					let message = i18n.t('dialogs.available_carnet.part_1', 'Per la tratta') + ' ' +
							bookingStore.searchFilters.departureStation.name + ' => ' + bookingStore.searchFilters.arrivalStation.name;
					message += ' ' + i18n.t('dialogs.available_carnet.part_2', 'non sono sidponibili carnet del tipo scelto') +
							' ( ' + bookingStore.carnet.list.find((carnet) => {
								if (carnet.id == bookingStore.carnet.selectedCarnetId) {
									return carnet;
								}
							}).displayName;
					message += ' ). ' + i18n.t('dialogs.available_carnet.part_3', 'Provare un un altro tipo di carnet o cambiare partenza/destinazione.');
					await dialogManagerStore.openSimpleMessageDialog({
						messageType: 'warning',
						text: message
					});
					stepper.goBack();
					return;
				} else if (response.errors) {
					let message = '';
					for (let error of response.errors) {
						message += error.toString() + ' ';
					}
					await dialogManagerStore.openSimpleMessageDialog({
						messageType: 'error',
						text: message
					});
					stepper.goBack();
				} else {
					// Rendo tutti i tipi di treno (frecciarossa, regionale, etc) un array di oggetti in modo che
					// carnet-solution possa ritrovare agevolmente le immagini
					for (let k in response.serviceMap.catalog_services) {
						if (!Object.hasOwnProperty.call(response.serviceMap.catalog_services, k)) continue;
						if (!Array.isArray(response.serviceMap.catalog_services[k].attrs.train_classification)) {
							let trainTmp = response.serviceMap.catalog_services[k].attrs.train_classification;
							response.serviceMap.catalog_services[k].attrs.train_classification = [];
							if ('string' == typeof trainTmp) {
								response.serviceMap.catalog_services[k].attrs.train_classification.push({value: trainTmp});
							} else {
								response.serviceMap.catalog_services[k].attrs.train_classification.push(trainTmp);
							}
						}

						// Stessa cosa per i nomi dei servizi
						if (!Array.isArray(response.serviceMap.catalog_services[k].attrs.level)) {
							let tmp = response.serviceMap.catalog_services[k].attrs.level;
							response.serviceMap.catalog_services[k].attrs.level = [];
							if ('string' == typeof tmp) {
								response.serviceMap.catalog_services[k].attrs.level.push({value: tmp});
							} else {
								response.serviceMap.catalog_services[k].attrs.level.push(tmp);
							}
						}
					}

					carnetSolutions.value = bookingStore.elaborateSearchResponseWithReturnTravelSolutions(JSON.parse(JSON.stringify(response)));
					setLoadingEvaluationList();
					if ('true' == import.meta.env.VITE_CACHE_CARNET) saveInLocalStore(response);
					loadingDialog.close();
					loading.value = false;
				}
			})
			.catch(async e => {
				console.error('searchAvailablesCarnet', e);
				loading.value = false;
				loadingDialog.close();
				await dialogManagerStore.showErrorDialogFromError(e);
				stepper.goBack();
			})
			.then(() => {
				loading.value = false;
				loadingDialog.close();
			});
}

function searchTravelSolutionsForFundCarnet() {
	const loadingDialog2 = dialogManagerStore.showLoadingDialog({
		title: i18n.t('dialogs.search_solutions.title', 'Ricerca soluzioni in corso ...')
	});
	loading.value = true;
	let dataToSend = {
		searchCriteria: {
			...bookingStore.searchFilters, ...{start: bookingStore.searchFilters.startDate.toISOString()},
			...{carnetId: bookingStore.carnet.selectedCarnetId}
		},
		offersAvailable: bookingStore.carnet.fund.services.offer,
		carnetEntitlementId: bookingStore.carnet.fund.entitlements.id,
		traveller: bookingStore.carnet.fund.travellers
	};

	axios.post("trenitalia/search-carnet-booking", dataToSend)
			.then((response) => response.data)
			.then(async (response) => {
				if (response.errors) {
					let message = '';
					for (let error of response.errors) {
						message += error.toString() + ' ';
					}
					await dialogManagerStore.showErrorDialogFromError({
						title: i18n.t('dialogs.warning'),
						message: message
					});
					stepper.goBack();
				} else {
					if (!isABooking.value && response.travelSolutions[0]) {
						response.travelSolutions = response.travelSolutions[0];
					}
					carnetSolutions.value = bookingStore.elaborateSearchResponseWithReturnTravelSolutions(JSON.parse(JSON.stringify(response)));
					setLoadingEvaluationList();
					if ('true' == import.meta.env.VITE_CACHE_CARNET) saveInLocalStore(response);
				}
			})
			.catch(async e => {
				console.error('searchAvailablesCarnet', e);
				loadingDialog2.close();
				loading.value = false;
				await dialogManagerStore.showErrorDialogFromError({
					title: i18n.t('dialogs.warning'),
					message: i18n.t('dialogs.errors.data_loading', 'C\'è stato un errore nel caricamento dei dati, per favore riprovare.')
				});
				stepper.goBack();
			})
			.then(() => {
				loadingDialog2.close();
				loading.value = false;
			});
}

// ?? convert in a watch?
function setLoadingEvaluationList() {
	for (let offerid in bookingStore.servicesMap.catalog_services) {
		if (!Object.hasOwnProperty.call(bookingStore.servicesMap.catalog_services, offerid)) continue;
		loadingEvaluation.value[offerid] = false;
	}
}

function cancelSelection() {
	selectedCarnet.value = -1;
	priceGrid.value = null;
	bookingStore.setEvaluatedSolution();
}

async function getAvailability(serviceID, invokedByAddToCart = false) {
	try {
		if (!invokedByAddToCart && !loginStore.isLogged) {
			const res = await loginStore.login();
			if (!res) return;
		}

		loadingEvaluation.value[serviceID] = true;
		let dialog;
		if (!invokedByAddToCart) dialog = dialogManagerStore.showLoadingDialog({
			title: i18n.t('dialogs.availability', 'Controllo disponibilità...')
		});
		let traveller, selectedTravelSolution, selectedOffer, customerKey;
		if (isABooking.value) {
			traveller = bookingStore.travellers;
			selectedTravelSolution = travelSolutionSelection.travelSolutionView.value.original;
			selectedOffer = [bookingStore.carnet.selectedService.serviceId];
		} else {
			traveller = {...bookingStore.travellers[0], ...bookingStore.buyer.data};
			selectedTravelSolution = travelSolution.value.original;
			selectedOffer = priceList.value[serviceID].offers;
			customerKey = bookingStore.buyer.data.customerKey;
		}
		let dataToSend = {
			travelSolutions: selectedTravelSolution,
			travellers: traveller,
			selectedOffer: selectedOffer,
			customerKey: customerKey
		};

		const avail = await bookingStore.getAvailability(dataToSend);
		const isSucess = handleEvaluateSolutionResponse(avail, i18n);
		loadingEvaluation.value[serviceID] = false;
		if (!invokedByAddToCart) dialog.close();
		if (!isSucess) return false;
		bookingStore.searchTravellers = avail.travellers;
		if (!isABooking.value) selectThisCarnet(serviceID);
		stepper.goNext();

		return true;
	} catch (e) {
		console.error('error getAvailability', e);
		loadingEvaluation.value[serviceID] = false;
		if (!invokedByAddToCart && dialog) dialog.close();
		return false;
	}
}

function selectThisCarnet(serviceID) {
	if (loginStore.isLogged) {
		selectedCarnet.value = serviceID;
		bookingStore.carnet.selectedService.serviceId = serviceID;
		// TODO: VERIFICARE IL CASO DI PIÙ CAMBI
		for (let xmlid in travelSolution.value.priceGrid) {
			if (!Object.hasOwnProperty.call(travelSolution.value.priceGrid, xmlid)) continue;
			priceGrid.value = travelSolution.value.priceGrid[xmlid];
			break;
		}
	}
}

async function addToCart() {
	bookingStore.carnet.loading = true;
	let dialog;
	let target;
	let resp;
	if (isABooking.value) {
		if (!loginStore.isLogged) {
			const res = await loginStore.login();
			if (!res) return;
		}

		dialog = dialogManagerStore.showLoadingDialog({
			title: i18n.t('dialogs.availability', 'Controllo disponibilità...')
		});

		resp = await getAvailability(bookingStore.carnet.selectedService.serviceId, true);
		target = 'booking-carnet';
	} else {
		dialog = dialogManagerStore.showLoadingDialog({
			title: i18n.t('dialogs.data_check', 'Verifica dati in corso ...')
		});
		if (invoiceForm.value.billingForm) {
			const {valid} = await invoiceForm.value.billingForm.validate();
			resp = valid;
		} else {
			resp = true;
		}
		target = 'buy-carnet';
	}

	if (!resp) {
		dialog.close();
		bookingStore.carnet.loading = false;
		return;
	}

	dialog.update({
		props: {
			title: i18n.t('dialogs.add_tocart', '...aggiungo al carrello...')
		}
	});

	const respATC = await bookingStore.addToCart(target);
	if (respATC.error) {
		dialog.close();
		await dialogManagerStore.showErrorDialogFromError({}, {
			message: respATC.message
		});
		return false;
	}

	dialog.close();
	bookingStore.carnet.loading = false;
}

watch(() => stepper.step, (step, oldStep) => {
	if (step != 'carnet-solutions') return;
	carnetSolutions.value = null
	if ('true' == import.meta.env.VITE_CACHE_CARNET) loadFromLocalStore();
	if (!carnetSolutions.value) {
		if (isABooking.value) {
			searchTravelSolutionsForFundCarnet();
		} else {
			searchAvailablesCarnet();
		}
	}
});

onMounted(() => {
	if (stepper.step == 'carnet-solutions') {
		if ('true' == import.meta.env.VITE_CACHE_CARNET) loadFromLocalStore();

		if (!carnetSolutions.value) {
			travelSolutionSelection.setSelectedSolution(null);
			// bookingStore.setSelectedCarnet(null);

			if (isABooking.value) {
				searchTravelSolutionsForFundCarnet();
			} else {
				searchAvailablesCarnet();
			}
		}
	}
});
</script>